// extracted by mini-css-extract-plugin
export default {"new-column-btn":"style_new-column-btn__BF41s","back-page-button":"style_back-page-button__2p5V1","board-wrapper":"style_board-wrapper__xx5Eb"};